import hyperform from "hyperform"
import Cleave from "cleave.js"
import { q } from "../../helper/q"

export const payFormInit = () => {
  const formElement = q(".profileFormPayment")
  if (!formElement) return null
  const priceValue = new Cleave("input[name=payvalue]", {
    numeral: true,
    numeralDecimalMark: ".",
    delimiter: " "
  })

  hyperform(formElement)

  hyperform.setRenderer("attachWarning", function(warning, element) {
    element.parentNode.classList.add("floatInputError")
    element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
  })

  formElement.addEventListener("submit", e => {
    e.preventDefault()

    ipayCheckout(
      {
        amount: priceValue.getRawValue(),
        currency: "RUB",
        order_number: q('input[name="paynumber"]').value,
        description: "Ингредиенты для пивоварения"
      },
      function(order) {
        showSuccessfulPurchase(order)
        formElement.reset()
      },
      function(order) {
        showFailurefulPurchase(order)
        formElement.reset()
      }
    )
  })
}

const showSuccessfulPurchase = () => {
  const element = q(".profileFormPaymentMessage")
  if (element) {
    element.classList.add("profileFormPaymentMessageSuccess")
    element.innerHTML = "Оплата прошла успешно!"
  }
}

const showFailurefulPurchase = () => {
  const element = q(".profileFormPaymentMessage")
  if (element) {
    element.classList.add("profileFormPaymentMessageError")
    element.innerHTML = "К сожалению, не удалось провести оплату. Повторите попытку или свяжитесь с нами."
  }
}
